import { LEGENDA } from '../dominio/didatico/tokens'
import { CLASSES_ACO, ORDEM_CLASSES_ACO } from '../dominio/didatico/classesAco'
import type { Camadas } from '../visualizacao3d/componentes/contextoMaquete'
import { ROTULOS_CAMADA } from './presetsModo'

interface Props {
  camadas: Camadas
  opacidadeCarroceria: number
  mostrarRotulos: boolean
  pinturaPorAco: boolean
  depuracaoHit?: boolean
  aoAlternarCamada: (chave: keyof Camadas) => void
  aoMudarOpacidade: (valor: number) => void
  aoAlternarRotulos: (valor: boolean) => void
  aoAlternarPinturaPorAco: (valor: boolean) => void
  aoAlternarDepuracaoHit?: (valor: boolean) => void
}

const ORDEM: Array<keyof Camadas> = [
  'estrutura',
  'zonaDeformacao',
  'srs',
  'retencao',
  'mecanica',
  'energia',
  'habitaculo',
]

export function PainelCamadas({
  camadas,
  opacidadeCarroceria,
  mostrarRotulos,
  pinturaPorAco,
  depuracaoHit = false,
  aoAlternarCamada,
  aoMudarOpacidade,
  aoAlternarRotulos,
  aoAlternarPinturaPorAco,
  aoAlternarDepuracaoHit,
}: Props) {
  return (
    <div className="grupo-controle">
      <span className="titulo-controle">Camadas</span>
      {ORDEM.map((chave) => (
        <label key={chave} className="toggle">
          <input type="checkbox" checked={camadas[chave]} onChange={() => aoAlternarCamada(chave)} />
          {ROTULOS_CAMADA[chave]}
        </label>
      ))}
      <label className="toggle">
        <input type="checkbox" checked={mostrarRotulos} onChange={(e) => aoAlternarRotulos(e.target.checked)} />
        rótulos na cena
      </label>

      {/* Fora da lista de camadas de propósito: camada esconde peça, isto pinta
          peça. Como caixa na mesma lista, o aluno leria "desliguei a estrutura"
          e "pintei por aço" como a mesma operação. */}
      <label className="toggle">
        <input
          type="checkbox"
          checked={pinturaPorAco}
          onChange={(e) => aoAlternarPinturaPorAco(e.target.checked)}
        />
        pintar por classe de aço
      </label>

      {aoAlternarDepuracaoHit && (
        <label className="toggle" title="Exibe vetor normal e ponto exato de acerto espacial (Atalho: Ctrl+H)">
          <input
            type="checkbox"
            checked={depuracaoHit}
            onChange={(e) => aoAlternarDepuracaoHit(e.target.checked)}
          />
          depuração espacial 3D (raycast)
        </label>
      )}

      <label className="deslizante">
        <span>
          carroceria <strong>{Math.round(opacidadeCarroceria * 100)}%</strong>
        </span>
        <input
          type="range"
          min="0"
          max="1"
          step="0.02"
          value={opacidadeCarroceria}
          onChange={(e) => aoMudarOpacidade(Number(e.target.value))}
          aria-label="Opacidade da carroceria"
        />
      </label>
    </div>
  )
}

/**
 * Legenda da cena.
 *
 * Acompanha a pintura por aço: com ela ligada a cena deixa de falar em
 * categorias e passa a falar em classes, e uma legenda que continuasse
 * descrevendo categorias estaria descrevendo outra imagem.
 */
export function Legenda({ pinturaPorAco = false }: { pinturaPorAco?: boolean }) {
  if (pinturaPorAco) {
    return (
      <div className="legenda">
        <span className="titulo-controle">Legenda · classes de aço</span>
        <ul>
          {ORDEM_CLASSES_ACO.map((classe) => (
            <li key={classe}>
              <i style={{ background: CLASSES_ACO[classe].cor }} />
              {CLASSES_ACO[classe].nome}
            </li>
          ))}
        </ul>
        <p className="nota-legenda">
          Construção provável desta maquete didática, não de um veículo real. A
          composição muda entre modelos e entre gerações do mesmo modelo:
          confirme na ficha de salvamento do veículo.
        </p>
      </div>
    )
  }

  return (
    <div className="legenda">
      <span className="titulo-controle">Legenda</span>
      <ul>
        {LEGENDA.map((entrada) => (
          <li key={entrada.categoria}>
            <i style={{ background: entrada.cor }} />
            {entrada.texto}
          </li>
        ))}
      </ul>
    </div>
  )
}
